import {z} from 'zod'
import {apiClient} from 'shared/apiClient'
import {forecastStatusActions} from 'shared/forecast/forecastTypes'
import {uri} from 'shared/uri'

export namespace Notify {
  const zOnQuestionChangedCommon = z.object({question_id: z.string()})
  export const zOnQuestionChanged = z.discriminatedUnion('part', [
    zOnQuestionChangedCommon.extend({part: z.literal('due')}),
    zOnQuestionChangedCommon.extend({
      part: z.literal('tasked'),
      mode: z.enum(['add', 'remove']),
      profile_id: z.string()
    }),
    zOnQuestionChangedCommon.extend({
      part: z.literal('forecast-status'),
      action: z.enum(forecastStatusActions),
      ids: z.array(z.string()),
      subject: z.string(),
      msg: z.string()
    })
  ])

  export const zNotifyOnAuthRequest = z.object({workspace_id: z.string(), email: z.string()})
  export const zNotifyFeedbackRequest = z.object({
    workspace_id: z.string(),
    msg: z.string(),
    to: z.enum(['active', 'all'])
  })

  type Part = z.infer<typeof zOnQuestionChanged>['part']
  export type OnQuestionChanged<T extends Part> = Extract<z.infer<typeof zOnQuestionChanged>, {part: T}>

  export const client = apiClient({
    md: {
      onQuestionChange: {zReq: zOnQuestionChanged},
      notifyOnAuthRequest: {zReq: zNotifyOnAuthRequest},
      notifyFeedbackRequest: {zReq: zNotifyFeedbackRequest},
      notifyOnComment: {
        zReq: z.object({
          id: z.string(),
          mode: z.enum(['edit', 'new']),
          question_id: z.string()
        })
      }
    },
    url: uri('/api/notify')
  } as const)

  export const onQuestionChange = client.makePost('onQuestionChange')
  export type OnQuestionChangeRequest = Parameters<typeof onQuestionChange>[0]

export const notifyOnAuthRequest = client.makePost('notifyOnAuthRequest')
  export type NotifyOnAuthRequestRequest = Parameters<typeof notifyOnAuthRequest>[0]

  export const notifyFeedbackRequest = client.makePost('notifyFeedbackRequest')
  export type NotifyFeedbackRequestRequest = Parameters<typeof notifyFeedbackRequest>[0]

  export const notifyOnComment = client.makePost('notifyOnComment')
  export type NotifyOnCommentRequest = Parameters<typeof notifyOnComment>[0]
}
